/* ============================================================
   SOLVEY · Carvacrol Complex page · module entry
   Stripped van Fase 1a hero/buybox-scaffolding.
   Fase B ports registreren hier hun init via runOnce(name, fn).
   ============================================================ */
(function () {
  'use strict';
  if (window.__solveyCarvacrolInit) return;
  if (!document.body.classList.contains('product-handle--carvacrol-complex-oregano-oil')) return;
  window.__solveyCarvacrolInit = true;

  // Fase B module placeholder — fixes D / F / E / A / B / C hooken hier in.
})();
